/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import DefaultAvatar from 'components/common/DefaultAvatar';
import { DEFAULT_FORMAT_DATE_US } from 'constants/days';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import moment from 'moment';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SelectedAppointmentContactAction from 'redux/selected-contact/selected-contact.action';
import SelectedAppointmentContactSelectors from 'redux/selected-contact/selected-contact.selectors';

import { useReadMessageCall } from '../helpers';
import { IChatRoomCardProps } from './types';

const ChatRoomCard: React.FC<IChatRoomCardProps> = ({ chatRoom, refetchChatRoomData }) => {
  const userId = useCurrentLoggedInUser().id;
  const selectedAppointmentContact = useSelector(SelectedAppointmentContactSelectors.selectAppointmentContact);
  const dispatch = useDispatch();
  const [triggerReadMessage] = useReadMessageCall();

  // useEffect(() => console.log('mount ====>'), []);

  // useEffect(() => console.log('Read message now ++++++++', chatRoom?.unreadMessagesCount, chatRoom?.id), [chatRoom]);
  if (!chatRoom) return null;

  const isSender = chatRoom.lastMessage?.from?.id === userId;
  const appointmentOfChatRoom = chatRoom.appointment;
  const { unreadMessagesCount } = chatRoom;
  const onChatRoomCardClick = async (e: any) => {
    e?.stopPropagation?.();
    dispatch(
      SelectedAppointmentContactAction.setSelectedAppointmentContact({
        id: chatRoom?.id,
        description: appointmentOfChatRoom?.description,
        date: appointmentOfChatRoom?.date,
        chatRoom,
      }),
    );
    if (chatRoom.id)
      triggerReadMessage({
        callbackOnSuccess: refetchChatRoomData,
        chatRoomId: chatRoom.id,
        totalUnreadMessages: unreadMessagesCount || 0,
      });
  };

  return (
    <div
      className={`conversation-card ${selectedAppointmentContact?.id === chatRoom?.id ? 'active' : ''} ${chatRoom?.id}`}
      onClick={onChatRoomCardClick}>
      {/* <div className='gx-size-30'>
        <Avatar
          src={
            appointmentOfChatRoom?.avatar?.thumbnailPipeFrom ||
            getDefaultAvatarUrl(`${appointmentOfChatRoom?.firstName} ${appointmentOfChatRoom?.lastName}`)
          }
          size={30}c
        />
      </div> */}
      <div className='conversation-info'>
        <div className='line-clamp line-clamp-1' style={{ wordBreak: 'break-all' }}>
          {appointmentOfChatRoom?.description || 'Notary Appointment'}
        </div>
        {appointmentOfChatRoom?.date && (
          <div className='line-clamp line-clamp-1' style={{ wordBreak: 'break-all' }}>
            On {moment(appointmentOfChatRoom.date).format(DEFAULT_FORMAT_DATE_US)}
          </div>
        )}
        <div className='line-clamp line-clamp-1' style={{ wordBreak: 'break-all' }}>
          {isSender ? 'You: ' : ''}
          {chatRoom.lastMessage?.message}
        </div>
      </div>
      <div className='message-time'>{moment(chatRoom.createdAt).fromNow()}</div>
      {!!unreadMessagesCount && (
        <div className='unread-message-count'>
          <DefaultAvatar size={15}>{unreadMessagesCount}</DefaultAvatar>
        </div>
      )}
    </div>
  );
};

export default ChatRoomCard;
